/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './ImageFragment';
export type MetafieldFragment = { __typename?: 'Metafield', id: string, type: string, namespace: string, key: string, value: string, createdAt: string, updatedAt: string, description?: string | null, reference?: { __typename: 'Collection' } | { __typename: 'GenericFile' } | { __typename: 'MediaImage', id: string, mediaContentType: Types.MediaContentType, image?: { __typename?: 'Image', id?: string | null, url: string, altText?: string | null, width?: number | null, height?: number | null } | null } | { __typename: 'Metaobject' } | { __typename: 'Model3d' } | { __typename: 'Page' } | { __typename: 'Product' } | { __typename: 'ProductVariant' } | { __typename: 'Video' } | null };

export declare const MetafieldFragment: import("graphql").DocumentNode;
export const MetafieldFragmentDoc = /*#__PURE__*/ `
    fragment MetafieldFragment on Metafield {
  id
  type
  namespace
  key
  value
  createdAt
  updatedAt
  description
  reference @include(if: $includeReferenceMetafieldDetails) {
    __typename
    ... on MediaImage {
      id
      mediaContentType
      image {
        ...ImageFragment
      }
    }
  }
}
    `;